import React from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'
import { Button } from '../root/components/common'

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        width: '400px',
        padding: '24px',
        flexDirection: 'column',
        alignSelf: 'center',
        alignItems: 'center',
        gap: '32px',
        borderRadius: '12px',
        boxShadow:
            '0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)'
    },
    videoTag: {
        width: '100%',
        height: '100%',
        maxHeight: '200px',
        borderRadius: '8px',
        border: 'none',
        outline: 'none'
    },
    textContainer: {
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
    },
    heading: { fontSize: '1.125rem', lineHeight: '1.75rem', fontWeight: 600 },
    text: { fontSize: '0.875rem', lineHeight: '1.25rem', textAlign: 'center' },
    buttons: { display: 'flex', gap: '12px', width: '100%' },
    fullWidth: { width: '100%' }
}))

export default function HotSwapWelcome({ setHasVisited }) {
    const { locale } = useSelector(state => state.main)
    const classes = useStyles()
    const handleNext = () => {
        setHasVisited(true)
    }
    return (
        <div className={classes.container}>
            <iframe
                className={classes.videoTag}
                src={`https://www.youtube.com/embed/nHA9DafWbBk`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                // eslint-disable-next-line
                allowFullScreen
                title="test"
            />
            <div className={classes.textContainer}>
                <Typography className={classes.heading}>
                    {locale.hotSwap.welcomeTitle}
                </Typography>
                <Typography className={classes.text}>
                    {locale.hotSwap.welcomeDesc}
                </Typography>
            </div>
            <div className={classes.buttons}>
                {/* <Button reverted onClick={skip} className={classes.fullWidth}>
                    {locale.common.skip}
                </Button> */}
                <Button onClick={handleNext} className={classes.fullWidth}>
                    {locale.common.next}
                </Button>
            </div>
        </div>
    )
}
